import type { LiquidAverageInsight } from "@tandemdiabetes/sugarmate-api-react-client"
import { LiquidUnit } from "@tandemdiabetes/sugarmate-api-react-client"
import { useCalculationsContext } from "../CalculationsContext"
import type { TileProps } from "./TileProps"
import { TileTimeSpan } from "./TileTimeSpan"
import { TileTitle } from "./TileTitle"
import { TileUnit } from "./TileUnit"
import { TileValue } from "./TileValue"
import { usePolyglot } from "src/contexts"
import { liquidMicrolitersToUnit } from "src/utils"

export function LiquidAverage(props: TileProps<LiquidAverageInsight>) {
  const {
    insightKey,
    range,
  } = props

  const polyglot = usePolyglot()
  const days = range / 24

  const { liquidCalculations } = useCalculationsContext()
  const { totalMicroliters } = liquidCalculations[range] || {}

  const value = totalMicroliters === undefined ?
    NaN :
    liquidMicrolitersToUnit(
      totalMicroliters / days,
      LiquidUnit.Milliliters,
    )

  const unit = polyglot.t(
    "unit.ml_day",
    isNaN(value) ? 0 : value,
  )

  return (
    <>
      <TileTitle insightKey={insightKey} />
      <TileTimeSpan
        id={`${insightKey}-time-range`}
        range={range}
      />
      <TileValue id={`${insightKey}-value`}>
        {isNaN(value) ? "--" : value.toLocaleString(polyglot.locale())}
      </TileValue>
      <TileUnit id={`${insightKey}-unit`}>
        {unit}
      </TileUnit>
    </>
  )
}
